module.exports = __webpack_public_path__ + "media/images/clickworker_com/f2a_step_3-a4e9a2badefb9f99b4f8b6c5e4f0e487.png";